import(/* webpackMode: "eager" */ "/app/src/app/service/layout.tsx");
